module.exports = __webpack_public_path__ + "img/cart.58aa2786.svg";